import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { ServiceCategorySubTypesListWrapper } from './servicecategorysubtypes-list/ServiceCategorySubTypesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const servicecategorysubtypesBreadcrumbs: Array<PageLink> = [
  {
    title: 'ServiceCategorySubType Management',
    path: '/admin/pages/servicecategorysubtypes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/servicecategorysubtypes/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const ServiceCategorySubTypesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='servicecategorysubtypes'
          index
          element={
            <>
              <PageTitle breadcrumbs={servicecategorysubtypesBreadcrumbs}>ServiceCategorySubTypes list</PageTitle>
              <ServiceCategorySubTypesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/servicecategorysubtypes/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/servicecategorysubtypes' />} />
    </Routes>
  )
}

export default ServiceCategorySubTypesPage
